import React from 'react';
export function Header() {
  return <header data-id="element-27">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-28">
        <div className="flex justify-between items-center text-gray-500 text-sm mb-4" data-id="element-29">
          <span data-id="element-30">Advertisement</span>
          <div className="flex items-center space-x-4" data-id="element-31">
            <span data-id="element-32">2 min read</span>
            <span data-id="element-33">842,035 Views</span>
          </div>
        </div>
      </div>
    </header>;
}